export default function () {
    return {}
}
